import { useState } from "react";
import { useParams } from "react-router-dom";
import { getSortedCollection } from "sprint-common-web";

import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { mapToOrderProxiesListingItem, OrderProxiesListingItem } from "./OrderProxiesListingItem";
import { OrderProxiesSectionFilters } from "./useOrderProxiesSectionFilters";

export const useOrderProxiesSection = () => {
    const { getProxiesByOrder } = useOrdersModuleApi();

    const { orderId } = useParams<{ orderId: string }>();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [allItems, setAllItems] = useState<OrderProxiesListingItem[]>();
    const [items, setItems] = useState<OrderProxiesListingItem[]>([]);

    const getData = async (): Promise<OrderProxiesListingItem[]> => {
        if (allItems) {
            return allItems;
        }

        const response = await getProxiesByOrder(orderId);
        const mappedItems = response.proxies.map(mapToOrderProxiesListingItem);

        setAllItems(mappedItems);

        return mappedItems;
    };

    const filterData = async (filters: OrderProxiesSectionFilters): Promise<void> => {
        setIsLoading(true);

        const listingItems = await getData();

        const sortedList = getSortedCollection(listingItems, filters.sortBy, filters.sortOrder);
        setItems(sortedList);

        setIsLoading(false);
    };

    return {
        isLoading,
        filterData,
        items
    };
};
